module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-tab tools-tab-duty"
  }, [_c('ul', {
    staticClass: "list list-duties"
  }, _vm._l((_vm.duties), function(duty) {
    return _c('li', {
      class: [_vm.hasDuty(duty) ? 'is-active' : ''],
      on: {
        "click": function($event) {
          return _vm.select(duty)
        }
      }
    }, [_c('em', {
      style: ('background:' + duty.color)
    }, [_vm._v(_vm._s(duty.identifier))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(duty.name))]), _vm._v(" "), _c('icon', {
      attrs: {
        "name": "check"
      }
    })], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d1e4529","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/tools/Duty.vue
// module id = 595
// module chunks = 225